import React, { Suspense } from "react";

/**
 * Wraps the React Component with React.Suspense and FallbackComponent while loading.
 * @param {React.ComponentType} WrappedComponent - Lazy-loaded component to wrap.
 * @param {React.ReactNode} [FallbackComponent=null] - Component to show while the WrappedComponent is loading.
 * @returns {React.ComponentType} - A new component wrapped with React.Suspense.
 */
const withSuspense = (WrappedComponent, FallbackComponent = null) => {
  return function WithSuspense(props) {
    const Fallback = FallbackComponent || <div>Loading...</div>; // Default fallback
    return (
      <Suspense fallback={Fallback}>
        <WrappedComponent {...props} />
      </Suspense>
    );
  };
};

export default withSuspense;
